<template>
  <div class="container">
        <div class="navi">
            <span class="close"><span class="icon-arrow-left" @click="goto('/')"></span></span>
            <div class="top-title">我的优惠券</div>
            <span></span>
        </div>

        <div class="weui-cells__title">领取优惠券</div>
        <div class="weui-cells">
          <div class="weui-cell couponPd">
              <div class="weui-cell__hd"><label class="weui-label">优惠码</label></div>
              <div class="weui-cell__bd">
                  <input class="weui-input text-right upperCase"  type="text" placeholder="点击输入优惠码" ref="couponRef" v-model="manualCoupon">
              </div>
              <div class="weui-cell__ft"  v-if="manualCoupon=='' || (manualCoupon!=order.data.coupon_id)">
                  <button class="weui-vcode-btn" @click="applyCoupon(manualCoupon,manualCoupon)">领取使用</button>
              </div>
              <div class="weui-cell__ft"  v-else>
                  <button class="weui-vcode-btn color-red" @click="cancelCoupon()">取消使用</button>
              </div>
          </div>
        </div>
        <br>

        <div v-if="!isEmpty">
          <div class="coupon-cell" v-for="item in orderList.on">
            <div class="left">
              <template v-if=" item.type=='1' ">
                <div><span class="dollar">$</span><span class="amountBig">{{item.amount | numeral('0,0')}} </span></div>
                <div class="subtitle">立减券</div>
              </template>
              <template v-else=" item.type=='2' ">
                <div class="amountBig">{{100-item.amount}}%</div>
                <div class="subtitle">OFF</div>
              </template>
            </div>
            <div class="middle">
              <div class="box">
              </div>
              <div class="flexbox">
                <div>
                  <div class="coupon-title">{{item.title}}</div>
                  <div class="coupon-date">有效期至：{{item.end}}</div>
                </div>
              </div>
            </div>

            <div class="right"  v-if="item.coupon_id == order.data.coupon_id">
              <a href="javascript:" @click="cancelCoupon()" class="weui-btn weui-btn_mini weui-btn_warn">取消</a>
            </div>

            <div class="right" v-else>
              <a href="javascript:" @click="applyCoupon(item.coupon_id, item.title)" class="weui-btn weui-btn_mini weui-btn_daojia">使用</a>
            </div>
          </div>
        </div>

        <div class="empty" v-show="isEmpty">
<!--           <img src="../../assets/img/misc/empty.svg">
 -->          <br>
          目前还没领到任何优惠券，如您有优惠码，可在上方输入使用
        </div> 

    <transition name="fade">
        <div id="loadingToast" v-show="isSending">
            <div class="weui-mask_transparent"></div>
            <div class="weui-toast">
                <i class="weui-loading weui-icon_toast"></i>
                <p class="weui-toast__content">正在加载</p>
            </div>
        </div>
    </transition>


    <div class="js_dialog" v-show="ifNotice">
        <div class="weui-mask"></div>
        <div class="weui-dialog">
            <div class="weui-dialog__hd"><strong class="weui-dialog__title">使用成功!</strong></div>
            <div class="weui-dialog__bd">优惠券使用成功，如满足使用条件，优惠金额将在支付尾款时自动生效</div>
            <div class="weui-dialog__ft">
                <div class="weui-dialog__btn weui-dialog__btn_daojia" @click="closeNotice()">好的</div>
            </div>
        </div>
    </div>

  </div>


</template>

<script>
import qs from 'qs'

export default {
  name: 'order',
  data () {
    return {
      isSending:false,
      payFilter:99,
      listObject:{},
      orderList:{},
      isEmpty:false,
      order:{},
      ifNotice:false,
      manualCoupon:'',
    }
  },
  methods: {
    applyCoupon(id,title){
      if(id==""){
        alert("优惠码不能为空")
      }
      else{
        this.orderUpdate('coupon_id',id);
        this.orderUpdate('coupon_title',title);
        this.ifNotice = true;
      }

    },
    cancelCoupon(){
      this.orderUpdate('coupon_id','');
      this.orderUpdate('coupon_title','');
      this.goto('/');
    },
    closeNotice: function() {
        this.ifNotice = false;
        this.goto('/');
    },
    getList(val){
      if(this.isSending){
        return false;
      }
      else{
        let listObject={};
        let that = this;
        this.isSending = true;

        listObject.token = localStorage.token;
        listObject.type_id = that.order.data.type_id;

        console.log(listObject);

        this.axios.post(this.apiURL()+'/Coupon/getCouponList', qs.stringify(listObject))
        .then(function (response) {
          if(response.data.error_code==0){
            that.isSending = false;
            that.orderList = response.data.data;
            if(that.orderList.on.length==0){
              that.isEmpty=true;
            }
            if(that.order.data.coupon_id){
              that.manualCoupon = that.order.data.coupon_id;
              for (let instance in that.orderList.on) {
                  if (that.orderList.on[instance].coupon_id === that.order.data.coupon_id) {
                    that.manualCoupon = ""
                  }
              }
            }
            window.scrollTo(0,0);
          }
          else{
            that.isSending=false;
          }
        })
        .catch(function (error) {
            alert("数据获取失败，请检查网络并重新尝试")
            that.isSending=false;
        });
      }
    },
  },
  computed: {
    service_period: function () {
      let result = '';
      switch (this.orderDetail.data.service_period) {
        case "am":
          result = '上午'
          break;
        case "pm":
          result = '下午'
          break;

        default:
          console.log("Sorry, we are out of service.");
      }
      return result;
    }
  },
  created: function () {
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      this.order = localParsed;
      if(this.order.data.coupon_id){
        this.manualCoupon = this.order.data.coupon_id;
        for (let instance in this.orderList.on) {
            if (this.orderList.on[instance].coupon_id === this.order.data.coupon_id) {
              this.manualCoupon = ""
            }
        }
      }
    }
    else{
      alert("下单数据异常")
    }
  },
  mounted: function () {
    if(this.checkLogin()){
      this.profileValidate();
      this.getList(99);
    }
    else{
      this.isEmpty = true;
    }
    document.querySelector("html").classList.add("grey-background-darker");
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background-darker");
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container{
  padding-top:70px;
}

.color-grey{
  color:#999;
}

.top-panel{
  position:fixed;
  left:0;
  top:0;
  width:100%;
  z-index:99;
}

.order-title{
  font-size:2em;
  color: #595D68;
  font-size: 20px;
  font-weight: bold;
  background:#fff;
  text-align:center;
  padding:1em 0 1em 0;
}

.payment-choose, .payment-choose-container{
  background:#fff;
}

.order-title-sub{
  padding:0 0 0 15px;
  color: #666;
  font-size: 16px;
  margin-bottom:2em;
}

.empty{
  padding:0 20vw;
  text-align:center;
  margin-top:6vh;
  color:#999;
}

.coupon-cell{
  margin:15px;
  margin-bottom:20px;
  background:#fff;
  border-radius:5px;
  border-left:4px solid $color-orange;

  .left{
    width:26%;
    text-align:center;
    padding: 12px 0;
    box-sizing: border-box;
    height: 100px;
  }
  .middle{
    width:50%;
    text-align:left;
    box-sizing: border-box;
    height: 100px;
    border-left: 1px dashed #ddd;
    position:relative;
    .flexbox{
      height:100px;
      display: flex;
      padding-left:20px;
      flex-direction: column;
      justify-content:space-around;
    }
  }
  .middle .box::after, .middle .box::before {
      content: '';
      position: absolute;
      width: 16px;
      height: 16px;
      background: #eee;
      border-radius: 100%;
  }
  .middle .box::before {
      top: -8px;
      left: -8px;
  }

  .middle .box::after {
      bottom: -8px;
      left: -8px;
  }
  .right{
      width:24%;
      display: flex;
      text-align:center;
      flex-direction: column;
      justify-content:space-around;
  }
}

.payment-choose{
  border-bottom:1px solid #eee;
  width:100%;
  margin:0 auto 0 auto;
  display: flex;
  justify-content:space-evenly;
  .payment{
    padding:1em 0.2em 0 0.2em;
  }
  .payment.active{
    color:#fe9567;
    border-bottom: solid 3px #fe9567;
    padding-bottom:0.6em;
  }
}


.weui-btn_daojia, .weui-btn_warn,{
  padding:2px 16px;
  color:#fff;
}

.coupon-cell{
  display: flex;
  justify-content:space-between;
}

.amountBig{
  font-size:2em;
  font-weight:bold;
  color:$color-orange;
}
.dollar{
  color:$color-orange;
  font-size:1.2em;
}
.subtitle{
  color:$color-orange;
  font-size:0.9em;
  margin-top:-8px;
}
.coupon-title{
  color:#595D68;
  font-weight:bold;
  line-height:1.2;
}

.coupon-date{
  color:#bbb;
  font-size:0.8em;
}

.navi{
    display: flex;
    justify-content:space-between;
    padding:0 0 0 0;
    position:fixed;
    top:0;
    left:0;
    width:100%;
    background:rgba(255, 255, 255, 0.9);
    z-index:999;
    span{
        flex: 1;
    }
    div{
        flex:2;
    }
    .close{
        text-align:left;
        font-size:1em;
        .icon-arrow-left{
            margin-right:12px;
            margin-top:10px;
            display:inline-block;
        }
    }
    .icon-arrow-left{
        padding-left:12pt;
    }
    .top-title{
        font-size:0.5em;
        line-height:3.2em;
        color:#444;
        vertical-align:top;
        display:inline-block;
        text-align:center;
    }
}

.modal-body{
  .modal-title{
    margin-bottom:14px;
  }
  .info{
    color:#222;
  }
}

.container /deep/{

  .couponPd{
    padding-top:0;
    padding-bottom:0;
  }

  .weui-vcode-btn{
    padding-right:0;
    margin-left:10px;
    color:#ff7444;
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/coupon/apply.vue